import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBooleanGroupUnion"><Path d="M21.5 2.5H8.5V8.5H2.5V21.5H15.5V15.5H21.5V2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBooleanGroupUnion;
